import { render, staticRenderFns } from "./LessonSelect.vue?vue&type=template&id=055234d6&scoped=true"
import script from "./LessonSelect.vue?vue&type=script&lang=js"
export * from "./LessonSelect.vue?vue&type=script&lang=js"
import style0 from "./LessonSelect.vue?vue&type=style&index=0&id=055234d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055234d6",
  null
  
)

export default component.exports